import { useCallback } from "react";
import { AgGridReact, Flex, Text, AgGrid, LoadingIndicator, Button, toast } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import {
  customComponent,
  loadingCellRendererContainer,
  loadingCellRendererText,
  loginButton,
  loginCell,
} from "./style_vanilla.css";

export const DashboardCell = ({ value }: AgGridReact.CustomCellRendererProps) => {
  return (
    <Flex flexDirection="row" alignItems="center" className={customComponent}>
      <Text variant="regular-md">{value}</Text>
    </Flex>
  );
};

export const LoginCell = ({ value }: AgGridReact.CustomCellRendererProps) => {
  const onClick = useCallback(() => {
    const url = `/session_exchange/initiate/${value.adminUserId}?arena_id=${value.arenaId}&sess_ex_type=ADMIN_TO_STAFF&redirect_url=/dashboard`;
    if (value.adminUserId && value.arenaId && value.active) {
      window.open(url, "_blank");
    } else {
      toast.error("There was an error navigating to the arena");
    }
  }, [value]);
  if (value.active) {
    return (
      <Flex flexDirection="row" alignItems="center" className={loginCell}>
        <Button
          iconPosition="right"
          icon="arrow-up-right-from-square"
          iconVariant="outline"
          variant="neutral"
          className={loginButton}
          onClick={onClick}
        >
          Log in
        </Button>
      </Flex>
    );
  }
  return <div />;
};

export const LoadingCellRenderer = (props: AgGrid.ICellRendererParams) => {
  if (props.node.failedLoad) {
    return (
      <Flex
        className={loadingCellRendererContainer}
        gap={8}
        data-testid="loading-error-container"
        alignItems="center"
      >
        <Icon type="xmark" variant="solid" color={Colors.Danger600} />
        <Text className={loadingCellRendererText}>Data failed to load</Text>
      </Flex>
    );
  }
  return <LoadingIndicator size="small" />;
};

export const StatusComponent = ({ value }: AgGridReact.CustomCellRendererProps) => {
  const color = value ? Colors.Success600 : Colors.Neutral600;
  const text = value ? "Active" : "Inactive";
  const iconType = value ? "toggle-on" : "toggle-off";
  return (
    <Flex flexDirection="row" alignItems="center" gap={8} className={customComponent}>
      <Icon type={iconType} variant="outline" color={color} size="medium" />
      <Text variant="strong-md" color={color}>
        {text}
      </Text>
    </Flex>
  );
};

export const AccessTypeComponent = ({ value }: AgGridReact.CustomCellRendererProps) => {
  const color = Colors.Neutral800;
  const iconType =
    value?.toLowerCase() === "named"
      ? "person-walking-arrow-right"
      : "person-walking-dashed-line-arrow-right";
  const text = value?.toLowerCase() === "named" ? "Named" : "Anonymous";
  return (
    <Flex flexDirection="row" gap={8} alignItems="center" className={customComponent}>
      <Icon type={iconType} variant="outline" color={color} size="medium" />
      <Text variant="strong-md" color={color}>
        {text}
      </Text>
    </Flex>
  );
};
